@reference '../../../../../../../../styles/tailwind.css';

.editor-content-plain {
  @apply px-4 py-[0.3rem] text-base leading-[1.75rem] text-pretty break-all caret-primary;
  @apply focus-visible:outline-hidden;

  & p {
    @apply my-0;
  }
}
